module.exports = __webpack_public_path__ + "static/img/003城市名片3.b2bdced.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/003城市名片3.jpg
// module id = mfkf
// module chunks = 0